'use strict'

import ColorsMath from './ColorsMath.js'

/**
 * LABColor
 * Workflow: store LAB components and provide helper utilities (LRV, ranges).
 */
class LABColor {
    /**
     * @param {number|Array<number>} l L component or [l, a, b] array.
     * @param {number} a A component.
     * @param {number} b B component.
     */
    constructor(l = 0.0, a = 0.0, b = 0.0) {
        if (Array.isArray(l)) {
            this.l = l[0]
            this.a = l[1]
            this.b = l[2]
            return
        }

        this.l = l
        this.a = a
        this.b = b
    }

    /**
     * Return LAB components as a numeric array.
     * @returns {number[]}
     */
    getLABColorAsDoubles() {
        return [this.l, this.a, this.b]
    }

    /**
     * Compute LRV (Light Reflectance Value) for this color.
     * @returns {number}
     */
    getLRV() {
        return ColorsMath.cxWhite_ref_obs10_ilD65.y * Math.pow((this.l + 16.0) / 116.0, 3.0)
    }

    /**
     * Clamp L to 0..100.
     * @param {number} lValue
     * @returns {number}
     */
    static inLRange(lValue) {
        return Math.max(0.0, Math.min(100.0, lValue))
    }

    /**
     * Clamp A/B to -128..128.
     * @param {number} abValue
     * @returns {number}
     */
    static inABRange(abValue) {
        return Math.max(-128.0, Math.min(128.0, abValue))
    }

    /**
     * Human-readable string representation.
     * @returns {string}
     */
    toString() {
        const l = Number(this.l).toFixed(2)
        const a = Number(this.a).toFixed(2)
        const b = Number(this.b).toFixed(2)
        return `LabColor - L=${l} - A=${a} - B=${b}`
    }
}

export default LABColor
